import { Controller } from '@hotwired/stimulus'

// Handles device toggles and sizing for the customer preview iframe
export default class extends Controller {
  static targets = ['container', 'iframe']

  static values = {
    device: { type: String, default: 'desktop' }
  }

  connect() {
    this.applyDevice(this.deviceValue)
  }

  setDevice(event) {
    const device = event?.params?.device || 'desktop'
    this.applyDevice(device)
  }

  applyDevice(device) {
    this.deviceValue = device
    if (this.hasContainerTarget) {
      this.containerTarget.dataset.device = device
    }

    // Sync active state on toggle buttons
    this.element.querySelectorAll('[data-preview-frame-device-param]').forEach((btn) => {
      btn.classList.toggle('active', btn.dataset.previewFrameDeviceParam === device)
    })
  }
}
